
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['currentDirectory']),
  },

  methods: {
    download() {
      const destination = new URL(
        '/api/archive',
        process.env.VUE_APP_SERVICE_BASE
      );

      destination.searchParams.append('path', this.currentDirectory.path());

      window.location.assign(destination.toString());
    },
  },
};
